import _ from "lodash";
import React from 'react';
import StatsTable from "./StatsTable";
import { LegoFiltersBar } from "../common/LegoFiltersBar";

const modelKey = (idModelo, year) => `${idModelo}-${year}`;


// This is the normal distribution of the relationship between car year and fusebox traffic in our site, aproximated with a normal distribution
const yearWeightsNormalDistribution = {
  "1990":	2.90,
  "1991":	4.02,
  "1992":	5.51,
  "1993":	7.41,
  "1994":	9.82,
  "1995":	12.79,
  "1996":	16.41,
  "1997":	20.72,
  "1998":	25.73,
  "1999":	31.46,
  "2000":	37.84,
  "2001":	44.79,
  "2002":	52.17,
  "2003":	59.81,
  "2004":	67.47,
  "2005":	74.89,
  "2006":	81.81,
  "2007":	87.94,
  "2008":	93.03,
  "2009":	96.84,
  "2010":	99.20,
  "2011":	100.00,
  "2012":	99.20,
  "2013":	96.84,
  "2014":	93.03,
  "2015":	87.94,
  "2016":	81.81,
  "2017":	74.89,
  "2018":	67.47,
  "2019":	59.81,
  "2020":	52.17,
  "2021":	44.79,
  "2022":	37.84,
  "2023":	31.46,
  "2024":	25.73,
  "2025":	20.72,
}

// Cars WITHOUT fuseboxes
const modelBlacklist = [
  'Tesla-Model 3',
  'Tesla-Model Y',
]

const modelIdYearBlacklist = [
  'Tesla-Model X-2022',
  'Tesla-Model X-2023',
  'Tesla-Model X-2024',
  'Tesla-Model X-2025',
  'Tesla-Model X-2026',
  'Tesla-Model S-2022',
  'Tesla-Model S-2023',
  'Tesla-Model S-2024',
  'Tesla-Model S-2025',
  'Tesla-Model S-2026',
]

export default class StatsFuseboxBySales extends StatsTable {
  filters = {
    country: 'ar',
    locale: window?.config?.locale || 'pt'
  }

  async fetchData() {
    this.salesByModelId = (await this.data.sales(this.filters.country))
    this.fuseboxes = (await this.data.fuseboxes(this.filters.locale)).fuseboxes;

    let flattenedFuseboxes = _.flatten(_.map(this.fuseboxes, (fb) => {
      return _.map(_.compact(_.flatten([fb.context])), ({ modelId, year }) => ({ ...fb, modelId, year }));
    }))

    let fuseboxesByModelYear = _.groupBy(flattenedFuseboxes, fb => fb.modelId + '-' + fb.year);

    this.salesByModelIdYear = _.flatMap(this.salesByModelId, (salesByYear, modelId) => {
      let numberSalesPairs = _.toPairs(salesByYear).filter(([year, sales]) => _.isNumber(sales));
      let averageSalesPerYear = _.sumBy(numberSalesPairs, '1') / numberSalesPairs.length;
      return _.map(salesByYear, (sales, year) => {
        let isAprox = false;
        if(sales === true) {
          sales = Math.floor(averageSalesPerYear/2);
          isAprox = true;
        }
        return { modelId, year, sales, isAprox, modelIdYear: modelId + '-' + year, fuseboxes: fuseboxesByModelYear[modelId + '-' + year] || [] };
      });
    }).filter(d => !modelBlacklist.includes(d.modelId) && !modelIdYearBlacklist.includes(d.modelIdYear));
  }

  extraFiltersComponent() {
      return <LegoFiltersBar fields={['country', 'locale']} filter={this.filters} onChange={this.onFilterChange.bind(this)} />
  }

  groups() {
    return this.salesByModelIdYear;
  }

  groupKey({ modelIdYear }) {
    return modelIdYear;
  }

  groupWeight(key, { sales, year }) {
    return sales * (yearWeightsNormalDistribution[year] || yearWeightsNormalDistribution['1990'])/100;
  }

  groupCoverage(key, { fuseboxes }) {
    return fuseboxes.length ? 1 : 0
  }

  displayGroup(modelKey, { modelId, year, sales, isAprox, fuseboxes }) {
    let fuseboxCount = <span className={fuseboxes.length ? 'text-success' : 'text-danger'}>{fuseboxes.length} fusebox</span>;

    return <div>{modelId} {year} <span className={`badge badge-secondary ${isAprox ? 'translucent' : ''}`}>{sales.toLocaleString()}{isAprox ? ' (proj.)' : ''} sales</span> {fuseboxCount}</div>;
  }
}